"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUnifiedDatum = getUnifiedDatum;
exports.getUnifiedData = getUnifiedData;
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash.uniqby"));

var _utils = require("../normalize/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function getUnifiedDatum(datum, index, config) {
  var apiPath = config.apiPath;
  var tag = config.tag || apiPath;
  var getDatumIdKey = config.getDatumIdKey || _utils.getDefaultDatumIdKey;
  var getDatumIdValue = config.getDatumIdValue || _utils.getDefaultDatumIdValue;

  var unifiedDatum = _objectSpread(_defineProperty({}, getDatumIdKey(datum), getDatumIdValue(datum, index)), datum);

  if (tag) {
    if (!unifiedDatum.__tags__) {
      unifiedDatum.__tags__ = [tag];
    } else {
      unifiedDatum.__tags__.push(tag);
    }
  }

  return unifiedDatum;
}

function getUnifiedData(data, config) {
  var getDatumIdValue = config.getDatumIdValue || _utils.getDefaultDatumIdValue;
  var unifyConfig = Object.assign({
    data: data
  }, config);
  var unifiedData = data.map(function (datum, index) {
    return getUnifiedDatum(datum, index, unifyConfig);
  });
  return (0, _lodash["default"])(unifiedData, getDatumIdValue);
}

var _default = getUnifiedData;
exports["default"] = _default;